function StartPage({ dispatch, numQuestions }) {
  return (
    <div className="start">
      <h2> Welcome to Reducer Quiz</h2>
      <h3> There are {numQuestions} questions in the test!</h3>
      <button
        className="btn btn-action"
        onClick={() => dispatch({ type: "start" })}
      >
        Start
      </button>
    </div>
  );
}

export default StartPage;
